import React from 'react';
import './About.scss';
import Bild1 from './images/DSC_0145.jpg'
import Bild3 from './images/20190922_1326121.jpg'
import Bild5 from './images/dsc_0001.jpg'
import Bild8 from './images/dsc_0016.jpg'
import Bild9 from './images/drabant.jpg'
import Bild10 from './images/Myrten9.jpg'
import Bild11 from './images/dsc_0026.jpg'
import Bild12 from './images/hjärta1.jpg'
import Bild13 from './images/hjärta2.jpg'
import Bild19 from './images/dsc_0389.jpg'
import Bild20 from './images/dsc_0390.jpg'
import Bild21 from './images/dsc_0393.jpg'
import Bild22 from './images/thumbnail_utomhus-1.jpg'
import Bild24 from './images/dsc_0008.jpg'
import Bild26 from './images/20190922_1323411.jpg'
import Bild27 from './images/DSC_0154.jpg'
import Arrow from './images/arrow.png'

class About extends React.Component {
  state = {
    photoIndex: 0
  }

  GetNextIndex = (modifier: number) => {
    if (this.state.photoIndex + modifier > photos.length - 1) {
      return 0;
    }
    else if (this.state.photoIndex + modifier < 0) {
      return photos.length - 1;
    }
    else
      return this.state.photoIndex + modifier;
  }

  render() {
    return <div>
      <div className='aboutContainer'>
        <img onClick={() => this.setState({ photoIndex: this.GetNextIndex(-1) })} className='arrow left' src={Arrow} alt='Error loading'></img>
        <img onClick={() => this.setState({ photoIndex: this.GetNextIndex(1) })} className='image' src={photos[this.state.photoIndex].src} alt='Error loading'></img>
        <img onClick={() => this.setState({ photoIndex: this.GetNextIndex(1) })} className='arrow right' src={Arrow} alt='Error loading'></img>
        <div className='textArea'>
          <br></br>
          <h1>Välkommen till Glimma Fastigheter</h1>
        Glimma Fastigheter AB är ett familjeägt fastighetsbolag med lägenheter,
        kontor och lokaler i Borås, Alingsås och Vänersborg. <br />Vi erbjuder ett varierat utbud.
      </div>
      </div>
    </div>
  }
}

export default About

const photos = [
  {
    src: Bild1
  },
  {
    src: Bild3
  },
  {
    src: Bild5
  },
  {
    src: Bild8
  },
  {
    src: Bild9
  },
  {
    src: Bild10
  },
  {
    src: Bild11
  },
  {
    src: Bild12
  },
  {
    src: Bild13
  },
  {
    src: Bild19
  },
  {
    src: Bild20
  },
  {
    src: Bild21
  },
  {
    src: Bild22
  },
  {
    src: Bild24
  },
  {
    src: Bild26
  },
  {
    src: Bild27
  }
];
